module.exports = __webpack_public_path__ + "media/images/pc/resort_plans/slider_button_next-d96b2aa78c45bcfe718047b8c3a8cc1e.svg";